import { type HTMLMotionProps, motion } from 'motion/react'
import { type Ref } from 'react'
import styles from './MentionUserPlaceholder.module.css'

export interface MentionUserPlaceholderProps extends HTMLMotionProps<'div'> {
	ref?: Ref<HTMLDivElement>
}

export default function MentionUserPlaceholder({ ref, ...props }: MentionUserPlaceholderProps) {
	return (
		<div className={styles.container} ref={ref}>
			<motion.div
				{...props}
				initial={{
					opacity: 0,
				}}
				animate={{
					opacity: 1,
				}}
				transition={{
					duration: 0.2,
				}}
				tabIndex={0}
				className={styles.root}
			>
				<div className={styles.avatarPlaceholder} />
				<div className={styles.namePlaceholder} />
			</motion.div>
		</div>
	)
}
